<template>
  <div class="booking-summary d-none d-xl-flex">
    <div class="container">
      <div class="row mb-4 justify-content-center">
        <div class="col-xl-6 mb-3">
          <div
            class="has-shadow panel panel--primary h-100 d-flex justify-content-center align-items-center flex-column p-3"
          >
            <span class="summary-title"> Your booking </span>
            {{ date }}
          </div>
        </div>

        <div class="col-xl-18 mb-3">
          <div class="row">
            <div class="has-shadow panel p-4 h-100">
              <div class="row">
                <spa-itinerary
                  v-bind:isSpaDay="isSpaDay"
                  v-bind:suppressMessage="true"
                ></spa-itinerary>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="booking-summary booking-summary-m d-xl-none">
    <div class="container-fluid g-0">
      <div class="row g-0 mb-4 justify-content-center">
        <div class="col-24 mb-3">
          <div
            class="has-shadow panel panel--primary h-100 d-flex justify-content-between align-items-between flex-column p-3"
          >
            <div class="row flex-row justify-content-between">
              <div class="col-12">
                <span class="summary-title"> Your booking </span>
              </div>
              <div class="col-12 d-flex justify-content-end">
                <button
                  type="button"
                  class="btn-summary"
                  v-bind:class="{ 'btn-summary--on': showSummary }"
                  v-on:click="showSummary = !showSummary"
                >
                  Show Summary
                </button>
              </div>
            </div>

            <div class="row mt-1" v-if="showSummary">
              <div class="col-24">
                <div
                  class="panel--primary h-100 d-flex justify-content-center align-items-start flex-column mb-4"
                >
                  <span style="font-size: 18px"
                    ><strong>Date: </strong> <br />{{ date }}</span
                  >
                </div>
              </div>

              <div class="col-24">
                <spa-itinerary
                  v-bind:isSpaDay="isSpaDay"
                  v-bind:suppressMessage="true"
                ></spa-itinerary>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from "../store/index";

import SpaItinerary from "../components/SpaItinerary.vue";
export default {
  name: "SpaBookingSummary",
  props: {
    isSpaDay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSummary: false,
    };
  },
  components: {
    SpaItinerary,
  },
  computed: {
    date() {
      var search = store.getters.search;
      var arrivalDate = moment(search.date);

      return arrivalDate.format("ddd Do MMM YY");
    },
  },
  methods: {
    priceFormatted(num) {
      if (num % 1 == 0) {
        return num;
      }

      return num.toFixed(2);
    },
  },
};
</script>

<style scoped>
.booking-summary {
  font-size: 14px;
  font-family: "Montserrat";
}

.booking-summary .summary-title {
  font-size: 24px;
  font-family: "Playfair Display";
}

.booking-summary .room {
  font-weight: bold;
  text-transform: uppercase;
}

.booking-summary .summary-label {
  font-weight: bold;
}

.booking-summary-m .panel {
  background: white;
  border: solid 1px #f1f1f1;
}

.btn-summary {
  border: none;
  background: none;
  background-image: url("@/assets/img/booking/summary-down.svg");
  background-size: 14px 7px;
  background-repeat: no-repeat;
  background-position: calc(100% - 10px) center;
  padding-right: 30px;
  text-align: left;
}

.btn-summary--on {
  background-image: url("@/assets/img/booking/summary-up.svg");
}
</style>
